// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071752/js/" + chunkId + "." + {"44":"5aad0cee","225":"6fc0687f","481":"8a705184","486":"802d0f21","770":"e2e9ac98"}[chunkId] + ".0.4437654928715654.chunk.js";
};